import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const reportService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/report/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching report list", error);
            throw error;
        }
    },

    async generateReport(reportType: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/report/generate/${reportType}`)
            return response.data;
        } catch (error) {
            console.error("Error generate summary report", error);
            throw error;
        }
    },

    async findByReportUuid(uuid: string): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/report/findByReportUuid/${uuid}`);
            return response.data;
        } catch (error) {
            console.error("Error findByReportUuid report", error);
            throw error;
        }
    },

    async save(report: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/report/save`,
                report
            );
            return response.data;
        } catch (error) {
            console.error("Error save report", error);
            throw error;
        }
    },

    async deleteById(reportId: string): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/report/deleteById/${reportId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById report", error);
            throw error;
        }
    },

    async generateReport1C(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/report/1c/${paramsCopy.filter.reportType}`,
                paramsCopy,
                {
                    responseType: 'blob',
                }
            )

            const blob = new Blob([response.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const fileName = `report-1c_${paramsCopy.filter.trancheNumber}.${paramsCopy.filter.trancheYear}.${paramsCopy.filter.reportType}.xlsx`;

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        } catch (error) {
            console.error("Error generating 1c report:", error);
            throw error;
        }
    },
}

export default reportService;
